import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApplicationParams, ApplicationStatus, ApplicationWithPage } from '@app/interfaces/lm/application';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ApplicationService {
    private baseUrl = environment.api.services.lm + '/application';

    constructor(private http: HttpClient) {}

    async find(params: ApplicationParams): Promise<ApplicationWithPage> {
        return lastValueFrom(this.http.get<ApplicationWithPage>(`${this.baseUrl}`, {
            params: Object.assign(params),
        }));
    }

    async changeStatus(data: ApplicationStatus): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}/status`, data));
    }
}
